import { useEffect } from 'react';
import type { SurrenderSettingsResponse } from 'src/apis/surrender-service/types';
import type { SurrenderRootRequest } from 'src/apis/surrender-service/use-surrender-root';
import { useAxios, type Successful } from 'src/hooks/use-axios';

type HookConfig = {
  surrenderRoot: SurrenderRootRequest;
};

type ExecuteProps = {
  surrenderRoot: Successful<SurrenderRootRequest>;
};

export function useSurrenderSettings({ surrenderRoot }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { surrenderRoot }: ExecuteProps) => {
      const url = surrenderRoot.response.data._links.getSettings?.href;
      return axios.request<SurrenderSettingsResponse>({
        method: 'GET',
        ...baseConfig,
        url,
      });
    },
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!surrenderRoot.response) return;
    if (!surrenderRoot.response.data._links.getSettings) return;

    request.execute({ surrenderRoot });
    // oxlint-disable-next-line exhaustive-deps
  }, [surrenderRoot.response]);

  if (!surrenderRoot.response) return;
  if (!surrenderRoot.response.data._links.getSettings) return;

  return request;
}

export type SurrenderSettingsRequest = ReturnType<typeof useSurrenderSettings>;
